import { Icon } from 'common/icon';

import styles from './styles.module.css';

export const MenuSupport = () => {
  const openSupportChat = () => {
    window.$chatwoot?.toggle?.();
  };

  return (
    <div onClick={openSupportChat} className={styles.container}>
      <div className={styles.menu__btn}>
        <Icon.Headphones width={26} height={26} color="white" />
      </div>
    </div>
  );
};
